import { Component} from '@angular/core';

@Component({
  selector: 'app-package-dialog',
  templateUrl: './package-dialog.component.html',
  styleUrls: ['./package-dialog.component.css']
})
export class PackageDialogComponent {

  constructor() {
     // This is intentional.
  }

}
